<template>
  <div class="boss-page ranking-page">
    <header class="boss-header">
      <van-icon name="arrow-left" @click="$router.back()"/>
      <span>日志综合榜</span><i></i></header>
    <div class="date-bar">
      <van-icon name="arrow-left" @click="shift(-1)"/>
      <strong>{{ dateLabel }}</strong>
      <van-icon name="arrow" @click="shift(1)"/>
    </div>
    <div class="tabs">
      <button v-for="tab in tabs" :key="tab.code" :class="{active: dimension === tab.code}" @click="dimension=tab.code">{{ tab.label }}</button>
    </div>
    <div v-if="loading" class="state">加载中...</div>
    <div v-else-if="error" class="state error">{{ error }}</div>
    <div v-else class="ranking-list">
      <section v-for="group in groups" :key="group.name" class="rank-group">
        <h3 v-if="group.name">{{ group.name }}</h3>
        <article v-for="(row,index) in group.rows" :key="row.userId || row.employeeName + index" class="rank-row">
          <b class="rank-no">{{ index + 1 }}</b><span class="avatar">{{ (row.employeeName || '?').slice(0, 1) }}</span>
          <div class="person"><strong>{{ row.employeeName || '未命名员工' }}</strong><small>{{ row.departmentName || '-' }} ·
            {{ row.positionName || '-' }}</small></div>
          <div class="metric" v-if="dimension === 'SUBMITTED_AT'"><strong :class="timeClass(row)">{{ timeText(row.submittedAt) }}</strong><small
            :class="timeClass(row)">{{ timeStatus(row) }}</small></div>
          <div class="metric" v-else><strong>{{
              scoreText(row.score)
            }}</strong><small>{{ row.score === null || row.score === undefined ? '未评分' : '综合分' }}</small></div>
        </article>
      </section>
    </div>
  </div>
</template>
<script>
import coreapi from '@/utils/coreapi';

export default {
  name: 'BossLogRankings', data() {
    return {
      date: this.$route.query.date || this.localDate(new Date()),
      dimension: ['SCORE', 'SUBMITTED_AT', 'ABILITY', 'BUSINESS_UNIT'].includes(this.$route.query.dimension) ? this.$route.query.dimension : 'SCORE',
      rows: [],
      loading: false,
      error: '',
      tabs: [{code: 'SCORE', label: '按分数'}, {code: 'SUBMITTED_AT', label: '按提交时间'}, {
        code: 'ABILITY',
        label: '按职能'
      }, {code: 'BUSINESS_UNIT', label: '按事业部'}]
    };
  }, computed: {
    dateLabel() {
      return this.date.replace(/-/g, '/');
    }, groups() {
      if (this.dimension === 'ABILITY' || this.dimension === 'BUSINESS_UNIT') {
        const map = {};
        this.rows.forEach(r => {
          const key = this.dimension === 'ABILITY' ? (r.departmentName || '未归属部门') : (r.businessUnit || '未归属事业部');
          (map[key] || (map[key] = [])).push(r);
        });
        return Object.keys(map).map(name => ({name, rows: map[name]}));
      }
      return [{name: '', rows: this.rows}];
    }
  }, created() {
    this.load();
  }, watch: {
    dimension() {
      this.load();
    }
  }, methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const data = await coreapi.bossLogRankings(this.date, this.dimension);
        this.rows = data.rows || [];
      } catch (e) {
        this.error = e.message || '服务调用失败';
      } finally {
        this.loading = false;
      }
    }, shift(delta) {
      const d = new Date(this.date + 'T00:00:00');
      d.setDate(d.getDate() + delta);
      // 不使用 toISOString：其按 UTC 转换，在东八区会把本地零点回退一天，
      // 导致 8 月 27 日 ← 8 月 25 日、且无法从 25 日前进回 26/27 日。
      this.date = this.localDate(d);
      this.load();
    }, localDate(d) {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${y}-${m}-${day}`;
    }, timeText(v) {
      if (!v) return '--';
      const d = new Date(v);
      return isNaN(d) ? String(v) : d.toLocaleTimeString('zh-CN', {hour: '2-digit', minute: '2-digit'});
    }, timeStatus(r) {
      if (!r.submittedAt) return '未提交日志';
      if (!r.clockOutAt) return '暂无下班打卡';
      return new Date(r.submittedAt) <= new Date(r.clockOutAt) ? '打卡前发日志' : '打卡后发日志';
    }, timeClass(r) {
      return r.submittedAt && r.clockOutAt && new Date(r.submittedAt) > new Date(r.clockOutAt) ? 'late' : 'ontime';
    }, scoreText(v) {
      return v === null || v === undefined ? '--' : Number(v).toFixed(1);
    }
  }
};
</script>
<style scoped>
.boss-page {
  min-height: 100vh;
  background: #f6f7fb;
  color: #303133
}

.boss-header {
  height: 52px;
  background: linear-gradient(90deg, #26191b, #c9272c);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px;
  font-size: 20px
}

.boss-header i {
  width: 24px
}

.date-bar {
  height: 58px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 28px;
  font-size: 17px
}

.tabs {
  display: flex;
  background: #fff;
  border-top: 1px solid #f0f1f5;
  padding: 0 12px
}

.tabs button {
  flex: 1;
  border: 0;
  background: none;
  padding: 14px 4px;
  color: #697386;
  font-size: 14px
}

.tabs button.active {
  color: #d9272e;
  border-bottom: 2px solid #d9272e;
  font-weight: 600
}

.ranking-list {
  padding: 12px
}

.rank-group {
  margin-bottom: 12px
}

.rank-group h3 {
  font-size: 15px;
  margin: 8px 4px;
  color: #41475a
}

.rank-row {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 12px 10px;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(30, 35, 60, .05)
}

.rank-no {
  width: 22px;
  text-align: center;
  color: #e4a52f
}

.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #d9272e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px 0 4px
}

.person {
  flex: 1;
  min-width: 0
}

.person strong, .metric strong {
  display: block;
  font-size: 15px
}

.person small, .metric small {
  display: block;
  color: #9aa1b2;
  margin-top: 4px;
  font-size: 12px
}

.metric {
  text-align: right
}

.ontime {
  color: #239b5b !important
}

.late {
  color: #d9272e !important
}

.state {
  padding: 60px 20px;
  text-align: center;
  color: #9aa1b2
}

.state.error {
  color: #d9272e
}
</style>




// WEBPACK FOOTER //
// src/views/boss/LogRankings.vue